import { render } from "./DetalleProcesos.vue?vue&type=template&id=18f3f89b&scoped=true"
import script from "./DetalleProcesos.vue?vue&type=script&lang=js"
export * from "./DetalleProcesos.vue?vue&type=script&lang=js"

import "./DetalleProcesos.vue?vue&type=style&index=0&id=18f3f89b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18f3f89b"

export default script